class SteelSelection extends HTMLElement {
  constructor() {
    super();

    this.cta = document.querySelector('.product-form__submit[name="add"]');
    this.ctaLabel = this.cta.querySelector('.product-form__submit-text');
    this.mainVariantPicker = document.getElementById('product__variant-picker');
    this.mainQuantityInput = document.querySelector('.product input[name="quantity"]');

    this.quantity = Number(this.mainQuantityInput.value);
    this.selectedSteelInput = null;

    const steelOptionsDataElement = this.querySelector('#product__steel-options-data');
    if (!steelOptionsDataElement) return;

    this.steelOptionsData = JSON.parse(steelOptionsDataElement.textContent);
    this.steelOptionInputs = this.querySelectorAll('input[type="radio"]');

    this.init();
  }

  init() {
    this.initSteelSizeData();
    this.setMainProductSelectedVariant(this.mainVariantPicker.currentVariant);

    for (let i = 0; i < this.steelOptionInputs.length; i++) {
      const optionProductInput = this.steelOptionInputs[i];
      
      const optionProductId = optionProductInput.dataset.productId;
      const optionProductData = this.steelOptionsData[optionProductId];
      const viableVariant = optionProductData.variants.find(this.getSteelVariantViability.bind(this)); // each option product can have at most one viable variant
      
      if (viableVariant) {
        optionProductInput.removeAttribute("disabled");

        // Select first viable option
        if (!this.selectedSteelInput) {
          this.selectedSteelInput = optionProductInput;
          this.selectedSteelInput.checked = true;
          this.selectedSteelVariant = viableVariant;
        }
      } else {
        optionProductInput.checked = false;
        optionProductInput.setAttribute("disabled", true);
      }
    }

    // If no option products are viable, disable the Add to Cart CTA
    this.setCtaEnabled(!!this.selectedSteelInput);

    this.addEventListener('change', this.onOptionProductChange.bind(this));
    document.addEventListener('VariantChanged', this.onMainProductVariantChange.bind(this));
    //document.addEventListener('AddToCart', this.onAddToCart.bind(this));
    this.mainQuantityInput.addEventListener('change', this.onQuantityChange.bind(this));
  }

  initSteelSizeData() {
    this.skateSizeArray =  ["1", "1.5", "2", "2.5", "3", "3.5", "4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12"];
    this.skateLengthObject = {
      'fit1': ["N/A", "N/A", "N/A", "N/A", "N/A", "N/A", "238", "238", "246", "246", "254", "254", "263", "263", "272", "272", "280", "280", "288", "288", "296", "296", "306"],
      'fit2': ["N/A", "N/A", "N/A", "N/A", "N/A", "N/A", "238", "238", "246", "246", "254", "254", "263", "263", "272", "272", "280", "280", "288", "288", "296", "296", "306"],
      'fit3': ["N/A", "N/A", "N/A", "N/A", "N/A", "N/A", "238", "238", "246", "254", "254", "263", "263", "272", "272", "280", "280", "288", "288", "296", "296", "306", "306"],
      'd': ["212", "212", "221", "221", "230", "230", "238", "238", "246", "246", "254", "254", "263", "263", "272", "272", "280", "280", "288", "288", "296", "296", "306"],
      'ee': ["212", "212", "221", "221", "230", "230", "238", "238", "246", "254", "254", "263", "263", "272", "272", "280", "280", "288", "288", "296", "296", "306", "306"],
    }
    this.skateLengthToSteelSizeMap = {"212": "1", "221": "2", "230": "3", "238": "4", "246": "5", "254": "6", "263": "7", "272": "8", "280": "9", "288": "10", "296": "11", "306": "12" }
  }

  onOptionProductChange(event) {
    this.selectedSteelInput = event.target;
      
    const steelProductId = this.selectedSteelInput.dataset.productId;
    const steelProductData = this.steelOptionsData[steelProductId];
    this.selectedSteelVariant = steelProductData.variants.find(this.getSteelVariantViability.bind(this));
    this.setCtaEnabled(true);
  }

  onQuantityChange() {
    this.quantity = Number(this.mainQuantityInput.value);
    this.onMainProductVariantChange();
  }

  setMainProductSelectedVariant(variant) {
    this.mainProductSelectedVariant = variant;
    this.requiredSteelSize = this.getSelectedSkateRequiredSteelSize();
  }

  onMainProductVariantChange(event) {
    if (event) {
      // Triggered by changes in variant selectors
      this.setMainProductSelectedVariant(event.detail.variant);
    }

    let isSelectedSteelVariantViable = this.getSteelVariantViability(this.selectedSteelVariant);

    for (let i = 0; i < this.steelOptionInputs.length; i++) {
      const steelOptionInput = this.steelOptionInputs[i];
      
      const steelProductId = steelOptionInput.dataset.productId;
      const steelProductData = this.steelOptionsData[steelProductId];
      const viableSteelVariant = steelProductData.variants.find(this.getSteelVariantViability.bind(this)); // each option product can have at most one viable variant
      
      if (viableSteelVariant) {
        steelOptionInput.removeAttribute("disabled");
        
        // If previously selected variant no longer viable, select the earliest viable option
        if (!isSelectedSteelVariantViable) {
          this.selectedSteelInput = steelOptionInput;
          this.selectedSteelInput.checked = true;
          this.selectedSteelVariant = viableSteelVariant;
          isSelectedSteelVariantViable = true;
        }

        this.setCtaEnabled(true);
      } else {
        steelOptionInput.setAttribute("disabled", true);
        steelOptionInput.checked = false;
      }
    }

    // If no options are viable, disable the Add to Cart CTA
    if (!isSelectedSteelVariantViable) {
      this.selectedSteelInput = null;
      this.selectedSteelVariant = null;
      this.setCtaEnabled(false);
    }
  }

  /** Adds currently selected steel to cart, associating it with the given line_item_key */
  // onAddToCart(event) {
  //   if (!event?.detail?.line_item_key) return;
    
  //   // Private line item properties
  //   const properties = {
  //     "_hiddenFromCartCount": true,
  //     "_associatedWithLineItemKey": event.detail.line_item_key,
  //   };
  //   // Public line item properties
  //   properties[window.Resources.pdp.steel_selection.added_with] = this.mainProductSelectedVariant.name;
    
  //   const body = JSON.stringify({
  //     id: this.selectedSteelVariant.id, 
  //     quantity: this.quantity,
  //     properties,
  
  //   });
   
  //   fetch(`${window.routes.cart_add_url}`, {...fetchConfig(), ...{ body }});
    
  // }

  getSelectedSkateRequiredSteelSize() {
    const skateSize = this.mainProductSelectedVariant.option1;
    const skateWidth = this.mainProductSelectedVariant.option2.toLowerCase().replace(/\s/g, '');

    const skateSizeIndex = this.skateSizeArray.indexOf(skateSize);
    const skateLength = this.skateLengthObject[skateWidth][skateSizeIndex];
    const requiredSteelSize = this.skateLengthToSteelSizeMap[skateLength];

    return requiredSteelSize;
  }

  getSteelVariantViability(steelVariant) {
    if (!steelVariant) return false;

    const hasSufficientQty = steelVariant.quantity >= this.quantity || (steelVariant.quantity === 0 && steelVariant.available)
    const matchesRequiredSteelSize = steelVariant.option1.toString() === this.requiredSteelSize;    

    return hasSufficientQty && matchesRequiredSteelSize;
  }

  setCtaEnabled(isEnabled) {
    // If the CTA is already disabled, it means the main product is out of stock. Don't do anything.
    if (this.cta.getAttribute('disabled')) return;

    if (isEnabled) {
      const skatePrice = Number(document.querySelector(".price-item")?.dataset?.price);
      const totalPrice = (skatePrice + this.selectedSteelVariant.price)/100;
      const displayPrice = totalPrice.toLocaleString(undefined, {style: 'currency', currency: this.dataset.currencyCode});
  
      this.ctaLabel.textContent = `${window.variantStrings.addToCart} - ${displayPrice}`;
    } else {
      this.cta.setAttribute('disabled', 'disabled');
      this.ctaLabel.textContent = window.Resources.pdp.steel_selection.steel_out_of_stock;
    }
  }
}

customElements.define('steel-selection', SteelSelection);
